import React from 'react'
import { DiscountedCashFlowResponseData } from '../Config/types'
import Spinner from './Spinner'
import IntrinsicValueOutputTable from './IntrinsicValueOutputTable'
import PlaceholderText from './PlaceholderText'
import { TableWrapper } from './Layout'

interface ValuationContentProps {
  discountedCashFlowResponseData: DiscountedCashFlowResponseData | null
  loading: boolean
}

export const ValuationContent: React.FC<ValuationContentProps> = ({
  discountedCashFlowResponseData,
  loading,
}) => {
  if (loading && !discountedCashFlowResponseData) {
    return <Spinner />
  }

  if (discountedCashFlowResponseData) {
    return (
      <TableWrapper>
        <IntrinsicValueOutputTable responseData={discountedCashFlowResponseData} />
      </TableWrapper>
    )
  }

  return <PlaceholderText />
}

export default ValuationContent
